import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";
import { assessmentsTableAddButtonContainer } from "../../assessmentsTableStyles";

export const useScenarioAssessmentsTableStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        riskCell: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
        },
        treatmentCell: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(0.5),
        },
        addButtonContainer: assessmentsTableAddButtonContainer,
    });
};
